export default __webpack_public_path__ + "static/media/data-center.0f5f1439.svg";